import React__default from 'react';
import { Image } from '@deal/components';
import { useApplicationContext, Application } from '../../../containers/ApplicationContext/index.js';
import MessageBubble from '../../MessageBubble/index.js';
import MessageBubbleText from '../../MessageBubbleText/index.js';
import { BusinessRichCardEvents } from '../../../containers/RichCardEventEmitter/BusinessEventData/index.js';
import { SharedRichCardEvents } from '../../../containers/RichCardEventEmitter/SharedEventData/index.js';
import { useRichCardEventEmitter } from '../../../containers/RichCardEventEmitter/index.js';
import { requestPriceMatchRichCard } from '../../../services/richCardFactory.js';
import CallToAction from '../components/CallToAction/index.js';
import numeral from 'numeral';
import { SellableForPriceMatchComponent } from './SellableForPriceMatch.generated.js';
import styles from './styles.css.js';

var SellablePriceMatchMessage = function SellablePriceMatchMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  var richCardEventEmitter = useRichCardEventEmitter();
  var application = useApplicationContext().application;
  var oneDayAgoDate = new Date().getTime() + 1 * 24 * 60 * 60 * 1000;
  var isMessageExpired = oneDayAgoDate < message.sentAt.toDate().getTime();
  var richCard = requestPriceMatchRichCard(message);
  return React__default.createElement(SellableForPriceMatchComponent, {
    variables: {
      id: richCard.sellableId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.sellable) {
      var image = data.sellable.images[0];
      var title = data.sellable.title;
      return React__default.createElement(React__default.Fragment, null, React__default.createElement(MessageBubble, {
        message: message
      }, React__default.createElement("div", {
        className: styles.sellableRow
      }, React__default.createElement("div", {
        className: styles.clickableTitle,
        onClick: function onClick() {
          (application === Application.CONSUMER || application === Application.BUSINESS) && (richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: SharedRichCardEvents.VIEW_SELLABLE,
            id: data.sellable.id,
            slug: data.sellable.slug,
            friendlyId: data.sellable.friendlyId,
            sellableType: data.sellable.type,
            url: data.sellable.consumerUrl
          }));
        }
      }), React__default.createElement("div", {
        className: styles.sellableImage
      }, React__default.createElement(Image, {
        src: image.url,
        width: 50,
        className: styles.sellableIconImage
      })), React__default.createElement("div", {
        className: styles.sellableTitle
      }, title)), React__default.createElement("div", {
        className: styles.copyRow
      }, "I would like to request a price match."), richCard.otherRetailPrices.length > 0 && React__default.createElement("div", {
        className: styles.prices
      }, React__default.createElement("div", {
        className: styles.variantRow
      }, React__default.createElement("div", {
        className: styles.retailer
      }, "Curated"), React__default.createElement("div", {
        className: styles.price
      }, numeral(richCard.price).format('$0,0.00'))), richCard.otherRetailPrices.map(function (onlineRetailer) {
        return React__default.createElement(React__default.Fragment, {
          key: onlineRetailer.retailer
        }, onlineRetailer.price < richCard.price && React__default.createElement("div", {
          className: styles.variantRow
        }, React__default.createElement("div", {
          className: styles.retailer
        }, onlineRetailer.retailer), React__default.createElement("div", {
          className: styles.lowerPrice
        }, numeral(onlineRetailer.price).format('$0,0.00'))));
      })), application === Application.BUSINESS && React__default.createElement(React__default.Fragment, null, isMessageExpired ? React__default.createElement(CallToAction, {
        disabled: true
      }, "This request has expired") : React__default.createElement(CallToAction, {
        onClick: function onClick() {
          richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: BusinessRichCardEvents.OPEN_QUICK_CURATION_FLYOUT
          });
        }
      }, "Add to Curation"))));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading messages!");
    }
  });
};

SellablePriceMatchMessage.handlesMessage = function (message) {
  return !!requestPriceMatchRichCard(message);
};

export default SellablePriceMatchMessage;
//# sourceMappingURL=index.js.map
